import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "./index.css";
import App from "./App";
import { NotificationProvider } from "@/components/NotificationProvider";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { store } from "@/store";
import "@rainbow-me/rainbowkit/styles.css";
import {
  getDefaultConfig,
  RainbowKitProvider,
  Chain,
  midnightTheme,
} from "@rainbow-me/rainbowkit";
import { WagmiProvider, http } from "wagmi";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

// Test network configuration (unused in production)
// const evm_test = {
//   id: 945,
//   name: "Subtensor EVM Test",
//   iconUrl: "https://s2.coinmarketcap.com/static/img/coins/64x64/5805.png",
//   iconBackground: "#fff",
//   nativeCurrency: { name: "Tao", symbol: "TAO", decimals: 18 },
//   rpcUrls: {
//     default: { http: ["https://test.chain.opentensor.ai"] },
//   },
//   blockExplorers: {
//     default: { name: "Taostats EVM Test", url: "https://taostats.io/evm/" },
//   },
// } as const satisfies Chain;

const evm = {
  id: 964,
  name: "Subtensor EVM",
  iconUrl: "https://s2.coinmarketcap.com/static/img/coins/64x64/5805.png",
  iconBackground: "#fff",
  nativeCurrency: { name: "Tao", symbol: "TAO", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://lite.chain.opentensor.ai"],
    },
  },
  blockExplorers: {
    default: { name: "Taostats EVM", url: "https://evm.taostats.io" },
  },
} as const satisfies Chain;

const config = getDefaultConfig({
  appName: "TaoLend",
  projectId: "119a9c8c3d8e7320d18ca82923cc513e",
  chains: [evm],
  transports: {
    // Use proxy in dev, direct URL in production
    [evm.id]: http(
      import.meta.env.DEV ? "/rpc" : "https://lite.chain.opentensor.ai"
    ),
  },
});
const queryClient = new QueryClient();
const root = document.getElementById("root");
// const { locale } = useRouter() as { locale: Locale };
if (root) {
  createRoot(root).render(
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#E8850F", // 修改主题色
          colorPrimaryBorder: "#E8850F",
          colorTextDisabled: "#FFFFFF29",
          colorBgBase: "#363636",
          colorBgContainer: "#25221A",
          colorBorder: "#363636",
          colorText: "#FFF",
          colorTextPlaceholder: "#B9B9B9",
          controlOutline: "#E8850F",
          colorErrorOutline: "#ff4d4f",
          controlOutlineWidth: 0,
          boxShadow: "",
          borderRadius: 6,
          colorBgContainerDisabled: "#FFFFFF1F",
        },
        components: {
          Select: {
            optionSelectedBg: "#FFFFFF14", // 修改选中项背景
            optionSelectedColor: "#B9B9B9", // 修改选中项字体颜色
          },
          Form: {
            labelFontSize: 16, // 修改表单标签字体大小
          },
          Button: {
            colorPrimaryBgHover: "#F7931A",
            colorPrimaryTextHover: "#FDF5E7",
          },
        },
      }}
    >
      <BrowserRouter>
        <Provider store={store}>
          <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
              <RainbowKitProvider
                initialChain={evm}
                // showRecentTransactions={true}
                theme={midnightTheme()}
                // theme={darkTheme({
                //   accentColor: "#7b3fe4",
                //   accentColorForeground: "white",
                //   borderRadius: "medium",
                // })}
              >
                <NotificationProvider>
                  <App />
                </NotificationProvider>
              </RainbowKitProvider>
            </QueryClientProvider>
          </WagmiProvider>
        </Provider>
      </BrowserRouter>
    </ConfigProvider>
  );
}
